<template>
  <v-dialog :fullscreen="$vuetify.breakpoint.smAndDown" v-model="dialog" width="600" scrollable>
    <base-body-dialog title="Sửa hồ sơ Học viên" :loading="isLoading" @close="cancel" @save="save">
      <v-form ref="form" class="py-4">
        <div v-for="(section, index) in formSections" :key="index">
          <h3 class="mb-2" :key="`title-${index}`">{{ index + 1 }}. {{ section.title }}</h3>
          <component
            :is="section.component"
            :student="student"
            :rules="rules"
            :ref="section.ref"
            :key="`component-${index}`"
          />
        </div>
      </v-form>
    </base-body-dialog>
  </v-dialog>
</template>

<script>
import { mapActions } from 'vuex'
import { User } from '@/plugins/api'
import BaseBodyDialog from '@/components/basic/dialog/BaseBodyDialog.vue'

import StudentGeneralForm from '@/components/basic/form/StudentGeneralForm.vue'
import StudentContactForm from '@/components/basic/form/StudentContactForm.vue'
import StudentNoteForm from '@/components/basic/form/StudentNoteForm.vue'
import StudentFamilyForm from '@/components/basic/form/StudentFamilyForm.vue'
import StudentClassForm from '@/components/basic/form/StudentClassForm.vue'

export default {
  components: {
    BaseBodyDialog,
    StudentGeneralForm,
    StudentContactForm,
    StudentNoteForm,
    StudentFamilyForm,
    StudentClassForm,
  },
  data() {
    return {
      dialog: false,
      loading: 0,
      rules: {
        required: (value) => !!value || 'Trường này không được để trống',
        min: (v) => v.length >= 6 || 'Ít nhất 6 ký tự',
        email: (v) => /.+@.+/.test(v) || 'Email chưa đúng định dạng',
        dob: (v) =>
          /^(?:0[1-9]|[12]\d|3[01])([/.-])(?:0[1-9]|1[012])\1(?:19|20)\d\d$/.test(v) || 'Ngày sinh chưa đúng định dạng',
      },
      formSections: [
        { title: 'Thông tin cơ bản', component: 'student-general-form', ref: 'studentGeneralForm' },
        { title: 'Thông tin lớp học', component: 'StudentClassForm', ref: 'studentClassForm' },
        { title: 'Thông tin liên lạc', component: 'student-contact-form', ref: 'studentContactForm' },
        { title: 'Ghi chú về Học viên', component: 'student-note-form', ref: 'studentNoteForm' },
        { title: 'Thông tin gia đình', component: 'student-family-form', ref: 'studentFamilyForm' },
      ],
    }
  },
  props: {
    state: Boolean,
    hideAdvanceOption: Boolean,
    defaultPhone: String,
    defaultEmail: String,
    defaultName: String,
    defaultOveride: Object,
    student: Object,
  },
  computed: {
    isLoading() {
      return this.loading > 0
    },
  },
  methods: {
    ...mapActions('students', ['updateStudent', 'changeStudentClass']),
    ...mapActions('student', ['updateStudent', 'updateClassInMessageGroup']),
    async save() {
      try {
        this.$loading.active = true
        const formData = await this.collectFormData()
        await this.updateUserIfNeeded(formData.studentGeneralForm)
        await this.changeClassIfNeeded(formData.studentClassForm)
        await this.updateStudentData(formData)
        this.dialog = false
        this.$alert.success('Cập nhật Học viên thành công')
      } catch (error) {
        console.error('Error updating student:', error)
        this.$alert.error('Cập nhật Học viên thất bại')
      } finally {
        this.$loading.active = false
      }
    },
    async collectFormData() {
      const formData = {}
      for (const section of this.formSections) {
        formData[section.ref] = await this.$refs[section.ref][0].getData()
      }
      return formData
    },
    async updateUserIfNeeded(studentGeneralForm) {
      if (this.student.user && this.student.user.id) {
        if (
          this.student.name !== studentGeneralForm.name ||
          this.student.user.username !== studentGeneralForm.username
        ) {
          await User.update(this.student.user.id, {
            username: studentGeneralForm.username,
            username_indexing: studentGeneralForm.username.substr(5),
          })
        }
      }
    },
    async changeClassIfNeeded(studentClassForm) {
      if (
        this.student.currentClass &&
        studentClassForm &&
        studentClassForm.classObject &&
        this.student.currentClass.id !== studentClassForm.classObject.id
      ) {
        await this.changeStudentClass({
          studentId: this.student.id,
          newClass: studentClassForm.classObject,
        })
      }
    },
    async updateStudentData(formData) {
      const { studentGeneralForm, studentClassForm, studentContactForm, studentNoteForm } = formData
      const updateData = {
        id: this.student.id,
      }

      if (studentGeneralForm) {
        if (studentGeneralForm.name !== undefined) updateData.name = studentGeneralForm.name
        if (studentGeneralForm.username !== undefined) updateData.code = studentGeneralForm.username
        if (studentGeneralForm.formatedName !== undefined) updateData.formatedName = studentGeneralForm.formatedName
        if (studentGeneralForm.tags !== undefined) updateData.tags = studentGeneralForm.tags
        if (studentGeneralForm.nameToNumber !== undefined) updateData.nameToNumber = studentGeneralForm.nameToNumber
        if (studentGeneralForm.gender !== undefined) updateData.gender = studentGeneralForm.gender
        if (studentGeneralForm.dob !== undefined) updateData.dob = studentGeneralForm.dob
      }

      if (studentClassForm) {
        if (studentClassForm.class !== undefined) {
          updateData.classes = [studentClassForm.class]
          updateData.currentClass = studentClassForm.class
        }
        if (studentClassForm.grade !== undefined) updateData.grade = studentClassForm.grade
      }

      if (studentContactForm) {
        if (studentContactForm.phone !== undefined) updateData.phone = studentContactForm.phone
        if (studentContactForm.currentLive !== undefined) updateData.address = studentContactForm.currentLive
        if (studentContactForm.email !== undefined) updateData.email = studentContactForm.email
      }

      if (studentNoteForm && studentNoteForm.notes !== undefined) {
        updateData.notes = studentNoteForm.notes
      }

      updateData.data = {
        ...this.student.data,
        ...(studentGeneralForm || {}),
        ...(studentContactForm || {}),
        ...(formData.studentFamilyForm || {}),
        ...(studentNoteForm || {}),
      }

      await this.updateStudent(updateData)
    },
    cancel() {
      this.dialog = false
    },
  },
  watch: {
    state() {
      this.dialog = true
    },
  },
}
</script>
